import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';

import * as ActionTypes from './actions';

export const initialState = {
  iframeLink: '',
  iframeIsLoaded: false,
  contactIframe: null,
  authUrl: '',
  authUrlIsLoaded: false,

  channels: [],
  channelsAreLoaded: false,

  needAuth: false,

  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_WAZZUP_IFRAME[REQUEST]:
      return {
        ...state,
        iframeIsLoaded: false,
      };

    case ActionTypes.GET_WAZZUP_IFRAME[SUCCESS]:
      return {
        ...state,
        iframeLink: action.data.link,
        iframeIsLoaded: true,
        needAuth: false,
      };

    case ActionTypes.GET_WAZZUP_IFRAME[FAILURE]:
      return {
        ...state,
        iframeIsLoaded: false,
        error: action.error,
      };

    case ActionTypes.GET_WAZZUP_CONTACT_IFRAME[REQUEST]:
      return { ...state, contactIframe: { contactId: action.contactId, status: null, link: null } };

    case ActionTypes.GET_WAZZUP_CONTACT_IFRAME[SUCCESS]:
      if (state.contactIframe?.contactId !== action.contactId) return state;
      return { ...state, contactIframe: { contactId: action.contactId, status: action.status, link: action.link } };

    case ActionTypes.GET_WAZZUP_CONTACT_IFRAME[FAILURE]:
      if (state.contactIframe?.contactId !== action.contactId) return state;
      return { ...state, contactIframe: { contactId: action.contactId, status: action.status, link: null } };

    case ActionTypes.CLEAR_WAZZUP_CONTACT_IFRAME:
      if (state.contactIframe?.contactId !== action.contactId) return state;
      return { ...state, contactIframe: null };

    case ActionTypes.SET_WAZZUP_NEED_AUTH:
      return {
        ...state,
        needAuth: action.value,
      };

    case ActionTypes.GET_WAZZUP_AUTHORIZE_URL[REQUEST]:
      return { ...state, authUrl: '', authUrlIsLoaded: false };

    case ActionTypes.GET_WAZZUP_AUTHORIZE_URL[SUCCESS]:
      return { ...state, authUrl: action.data.link, authUrlIsLoaded: true };

    case ActionTypes.GET_WAZZUP_AUTHORIZE_URL[FAILURE]:
      return { ...state, authUrl: '', authUrlIsLoaded: false };

    case ActionTypes.GET_WAZZUP_CHANNELS[REQUEST]:
      return {
        ...state,
        channelsAreLoaded: false,
      };

    case ActionTypes.GET_WAZZUP_CHANNELS[SUCCESS]:
      return {
        ...state,

        channels: action.data.map(channel => ({
          value: channel.channelId,
          label: channel.name || channel.phone || channel.transport,
          transport: channel.transport,
        })),

        channelsAreLoaded: true,
      };

    case ActionTypes.GET_WAZZUP_CHANNELS[FAILURE]:
      return {
        ...state,
        channelsAreLoaded: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
